import { QueryOptions, useQuery } from '@tanstack/react-query';

import { fetchMerchant, fetchMerchantV2 } from 'apis/restaurant-api/merchant-admin/merchant/api';
import { MerchantDetail } from 'apis/restaurant-api/merchant-admin/merchant/types';

import { useIsMerchantV2ApiEnabled } from './useIsMerchantV2ApiEnabled';

export const useFetchMerchant = (
  merchantId: string | undefined,
  isMerchantFetchEnabled: boolean,
  additionalOptions: QueryOptions<MerchantDetail | undefined, unknown, MerchantDetail | undefined, string[]> = {},
) => {
  const { isMerchantV2ApiEnabled, isLoadingIsMerchantV2ApiEnabled } = useIsMerchantV2ApiEnabled(isMerchantFetchEnabled);

  const {
    data: merchant,
    error: merchantError,
    isLoading,
  } = useQuery(
    [isMerchantV2ApiEnabled ? '/v2' : '/v1', '/merchant-admin/merchants/', merchantId ?? ''],
    () => {
      if (!merchantId) {
        return;
      }
      if (isMerchantV2ApiEnabled) {
        return fetchMerchantV2(merchantId);
      }
      return fetchMerchant(merchantId);
    },
    {
      enabled: isMerchantFetchEnabled && !isLoadingIsMerchantV2ApiEnabled,
      refetchOnWindowFocus: false,
      ...additionalOptions,
    },
  );

  const isLoadingMerchant = isLoadingIsMerchantV2ApiEnabled || (isMerchantFetchEnabled && isLoading);

  return {
    merchant,
    merchantError,
    isLoadingMerchant,
  };
};
